<template>
  <div class="loader-flull">
    <h1>
      <span>L</span>
      <span>o</span>
      <span>a</span>
      <span>d</span>
      <span>i</span>
      <span>n</span>
      <span>g</span>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </h1>
  </div>
</template>

<script>
import { gsap } from 'gsap/all'

export default {
  mounted () {
    gsap.to('.loader-flull h1', {
      duration: 6,
      autoAlpha: 0
    })
    gsap.to('.loader-flull h1 span', {
      color: '#D1B13C',
      delay: 1,
      stagger: 0.2,
      onComplete: () => {
        this.$emit('hasLoaded', true)
        gsap.to('.loader-flull', {
          duration: 2.5,
          autoAlpha: 0
        })
      }
    })
  }
}
</script>

<style lang="scss">
@import "../assets/styles/breakpoints";
@import '../assets/styles/variables';
.loader-flull {
  overflow: hidden;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: $accent-block;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  h1 {
    display: inline-block;
    font-size: 80px;
    color: $sage;
    font-family: 'Autography', Courier, monospace;
  }
}
</style>
